module.exports = __webpack_public_path__ + "header-profile-skin-3.bf471ec3d4085883e061.png";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/patterns/header-profile-skin-3.png
// module id = 604
// module chunks = 2